import { AfterViewInit, Component, ChangeDetectorRef } from '@angular/core';
import { CurrencyService } from '../../../../shared/services/currency.service';

// extend
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { User } from '@app/shared/interfaces/user';
import { Router } from '@angular/router';
import { SiteViwModel } from '@app/shared/interfaces/SiteViewModel';
import { StoreService } from '@app/shared/services/store.service';
import { NavigationLink } from '@app/shared/interfaces/navigation-link';
import { accountnavigation } from '@data/account-navigation';
import { environment as env } from '@environments/environment';

@Component({
    selector: 'app-header-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements AfterViewInit {

    isMultiLanguage = env.multicurrency;
    isMultiCurrency = env.multicurrency;

    accountLinks: NavigationLink[] = accountnavigation;

    languages = env.defaultLanguages || [
        { name: 'English', image: 'language-1', dir: 'ltr', symbol: 'EN' }
    ];

    currencies = env.defaultCurrencies || [
        { name: '$ US Dollar', url: '', code: 'USD', symbol: '$' },
        { name: '€ Euro', url: '', code: 'EUR', symbol: '€' },
        { name: '£ Pound Sterling', url: '', code: 'GBP', symbol: '£' },
        { name: '₽ Russian Ruble', url: '', code: 'RUB', symbol: '₽' }
    ];

    // extend
    currentUser: User;
    detectedDirection = env.defaultDirection || 'ltr';
    currentLanguage = env.defaultLanguage || 'EN';

    // text
    theme = {
        language: 'Language',
        currency: 'Currency',
        myaccount: 'My Account',
        languages: env.defaultLanguages || [
            { name: 'English', image: 'language-1', dir: 'ltr', symbol: 'EN' },
        ],
        currencies: this.currencies
    };

    constructor(
        private router: Router,
        public currencyService: CurrencyService,
        private authenticationService: AuthenticationService,
        public storeService: StoreService,
        private cdr: ChangeDetectorRef

    ) {
        if (this.isMultiLanguage) {
            if (localStorage.getItem('lan')) {
                this.currentLanguage = localStorage.getItem('lan');
            } else {
                this.currentLanguage = env.defaultLanguage || 'EN';
                localStorage.setItem('lan', this.currentLanguage);
            }

            if (localStorage.getItem('dir')) {
                this.detectedDirection = localStorage.getItem('dir');
            } else {
                this.detectedDirection = env.defaultDirection || 'ltr';
                localStorage.setItem('dir', this.detectedDirection);
            }
        }

        this.authenticationService.currentUser.subscribe(x =>
            this.currentUser = x
        );

        if (localStorage.getItem('store')) {
            const store = JSON.parse(localStorage.getItem('store'));
            if (store.languages && store.languages.length) {
                this.languages = store.languages;
            }
            if (store.currencies && store.currencies.length) {
                this.currencies = store.currencies;
            }
        }
    }

    ngAfterViewInit(): void {
        this.cdr.detectChanges();
    }

    setCurrency(currency): void {
        this.currencyService.options = {
            code: currency.code,
            display: currency.symbol,
        };
        localStorage.setItem('currency', JSON.stringify(currency));
    }

    logout() {
        this.authenticationService.logout();
        this.router.navigate(['/account/login']);
    }

    changeLanguage(e) {
        localStorage.setItem('dir', e.dir);
        localStorage.setItem('lan', e.symbol.toUpperCase());
        document.location.reload();
    }


}